(() => {
  const form = document.querySelector('[data-ugc-form]');
  if (!form) return;

  const endpoint = form.dataset.endpoint;
  const formEl = form.querySelector('form');
  const submitBtn = form.querySelector('[data-ugc-submit]');
  const submitLabel = form.querySelector('[data-ugc-submit-label]');
  const submitLoading = form.querySelector('[data-ugc-submit-loading]');
  const status = form.querySelector('[data-ugc-status]');
  const successEl = form.querySelector('[data-ugc-success]');
  const preview = form.querySelector('[data-ugc-preview]');
  const captionCount = form.querySelector('[data-ugc-caption-count]');
  const captionInput = formEl.querySelector('[name="caption"]');
  const photoInput = formEl.querySelector('[name="photo"]');
  const yarnSelect = formEl.querySelector('[data-ugc-yarn-select]');

  function escAttr(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escText(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  async function loadAllYarns() {
    if (!yarnSelect) return;
    const handle = yarnSelect.dataset.sourceHandle || 'alle-garne';
    const collected = [];
    const PAGE_SIZE = 50;
    for (let page = 1; page <= 20; page++) {
      let res;
      try {
        res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${PAGE_SIZE}&page=${page}`, {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
      } catch (e) {
        break;
      }
      if (!res.ok) break;
      let data;
      try { data = await res.json(); } catch (e) { break; }
      const products = (data && data.products) || [];
      collected.push(...products);
      if (products.length < PAGE_SIZE) break;
    }

    if (collected.length === 0) {
      yarnSelect.innerHTML = '<option value="" disabled selected>' + bfT('ugc_yarns_error', 'Garne konnten nicht geladen werden — bitte Seite neu laden') + '</option>';
      return;
    }

    collected.sort((a, b) => {
      const va = String(a.vendor || '').toLowerCase();
      const vb = String(b.vendor || '').toLowerCase();
      if (va !== vb) return va.localeCompare(vb, 'de');
      return String(a.title || '').localeCompare(String(b.title || ''), 'de');
    });

    let html = '<option value="">— bitte wählen —</option>';
    let currentVendor = null;
    for (const p of collected) {
      if (p.vendor !== currentVendor) {
        if (currentVendor !== null) html += '</optgroup>';
        html += `<optgroup label="${escAttr(p.vendor)}">`;
        currentVendor = p.vendor;
      }
      const gid = `gid://shopify/Product/${p.id}`;
      html += `<option value="${escAttr(gid)}" data-handle="${escAttr(p.handle)}">${escText(p.title)}</option>`;
    }
    if (currentVendor !== null) html += '</optgroup>';
    yarnSelect.innerHTML = html;
  }

  function applyUrlPreselect() {
    if (!yarnSelect) return;
    const params = new URLSearchParams(window.location.search);
    const yarnHandle = params.get('yarn');
    if (!yarnHandle) return;
    const match = yarnSelect.querySelector(`option[data-handle="${CSS.escape(yarnHandle)}"]`);
    if (match) yarnSelect.value = match.value;
  }

  loadAllYarns().then(applyUrlPreselect);

  // Caption-Counter
  if (captionInput && captionCount) {
    const updateCount = () => { captionCount.textContent = captionInput.value.length; };
    captionInput.addEventListener('input', updateCount);
    updateCount();
  }

  // Photo-Preview
  if (photoInput && preview) {
    photoInput.addEventListener('change', () => {
      const file = photoInput.files && photoInput.files[0];
      if (!file) { preview.hidden = true; preview.innerHTML = ''; return; }
      if (file.size > 10 * 1024 * 1024) {
        setStatus('Foto ist größer als 10 MB.', 'error');
        photoInput.value = '';
        preview.hidden = true; preview.innerHTML = '';
        return;
      }
      const url = URL.createObjectURL(file);
      preview.innerHTML = `<img src="${url}" alt="Vorschau">`;
      preview.hidden = false;
    });
  }

  // Giveaway opt-in: toggle email field + required state
  const giveawayToggle = formEl.querySelector('[data-ugc-giveaway-toggle]');
  const giveawayFields = form.querySelector('[data-ugc-giveaway-fields]');
  const giveawayEmail = form.querySelector('[data-ugc-giveaway-email]');
  if (giveawayToggle && giveawayFields && giveawayEmail) {
    const syncGiveaway = () => {
      const on = giveawayToggle.checked;
      giveawayFields.hidden = !on;
      giveawayEmail.required = on;
      if (!on) giveawayEmail.value = '';
    };
    giveawayToggle.addEventListener('change', syncGiveaway);
    syncGiveaway();
  }

  // Submit
  formEl.addEventListener('submit', async (e) => {
    e.preventDefault();
    setStatus('', '');

    if (!formEl.reportValidity()) return;

    setLoading(true);

    const fd = new FormData(formEl);

    try {
      const res = await fetch(endpoint, { method: 'POST', body: fd });
      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.ok) {
        setStatus(data.error || bfT('ugc_generic_error', 'Etwas ist schiefgelaufen. Bitte später erneut versuchen.'), 'error');
        setLoading(false);
        return;
      }

      formEl.hidden = true;
      successEl.hidden = false;
      successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      setStatus(bfT('ugc_conn_error', 'Verbindungsfehler. Bitte später erneut versuchen.'), 'error');
      setLoading(false);
    }
  });

  function setLoading(loading) {
    submitBtn.disabled = loading;
    submitLabel.hidden = loading;
    submitLoading.hidden = !loading;
  }

  function setStatus(msg, kind) {
    status.textContent = msg;
    status.className = 'ugc-form__status' + (kind ? ` ugc-form__status--${kind}` : '');
  }
})();
